import { SqlQueryEffects } from './sql-query.effects';

export const effects: any[] = [SqlQueryEffects];

export * from './sql-query.effects';
